var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import CollectionView from "../presentation/collections";
import axios from "axios";
import CONSTS from "../consts";
const _ = require("lodash");
export default class Collections extends React.Component {
    constructor(props) {
        super(props);
        this.orderByOptions = [
            { label: 'Product Name - A - Z', value: 'Name+asc' },
            { label: 'Product Name - Z - A', value: 'Name+desc' },
            { label: 'SKU # - 0 - 9', value: 'DisplaySKU+asc' },
            { label: 'SKU # - 9 - 0', value: 'DisplaySKU+desc' }
        ];
        this.updateSubFilter = (newattr, TypeOptions) => {
            let currentFilter = this.state.filterOptions[TypeOptions].split(",").filter((x) => {
                return x.length > 0;
            });
            if (currentFilter.includes(newattr)) {
                currentFilter.splice(currentFilter.indexOf(newattr), 1);
            }
            else {
                currentFilter.push(newattr);
            }
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions[TypeOptions] = currentFilter.join(",");
            this.setState({
                filterOptions,
                products: [],
                count: 0,
                loading: true
            }, () => {
                this.getProducts(1);
            });
        };
        this.updateMinMaxFilter = (newattr, TypeOptions) => {
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions[TypeOptions] = newattr;
            this.setState({
                filterOptions,
                products: [],
                count: 0,
                loading: true
            }, () => {
                this.getProducts(1);
            });
        };
        this.updateAlbertaMade = (newValue) => {
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions.albertaMade = newValue;
            this.setState({
                filterOptions,
                products: [],
                count: 0,
                loading: true
            }, () => {
                this.getProducts(1);
            });
        };
        this.updateOrderBy = (orderBy) => {
            this.setState({ orderBy, loading: true, products: [] }, () => this.getProducts(1));
        };
        this.getFacet = (products, ftype) => {
            var filteredProducts = this.filterProducts(products, ftype);
            return _.chain(filteredProducts)
                .map(ftype)
                .map((facet) => {
                if (facet && typeof facet.trim === 'function') {
                    return facet.trim();
                }
                var parsedFloat = parseFloat(facet);
                if (!isNaN(parsedFloat)) {
                    return parsedFloat.toFixed(1);
                }
                return facet;
            })
                .filter(function (facet) {
                if (typeof facet !== 'string') {
                    return facet;
                }
                return facet.length > 0;
            })
                .sortBy((f) => f)
                .uniq()
                .value();
        };
        this.filterProducts = (products, excludeFilter = '') => {
            return _.chain(products)
                .filter((product) => {
                return excludeFilter != "Country" && this.state.filterOptions.country.length > 0
                    ? product.Country != null && this.state.filterOptions.country
                        .split(",")
                        .indexOf(product.Country.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "Vintage" && this.state.filterOptions.vintage.length > 0
                    ? product.Vintage != null && this.state.filterOptions.vintage
                        .split(",")
                        .indexOf(product.Vintage.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "Region" && this.state.filterOptions.region.length > 0
                    ? product.Region != null && this.state.filterOptions.region
                        .split(",")
                        .indexOf(product.Region.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "ConsumerCategory" && this.state.filterOptions.ConsumerCategory.length > 0
                    ? product.ConsumerCategory != null && this.state.filterOptions.ConsumerCategory.split(",").indexOf(product.ConsumerCategory.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "ConsumerType" && this.state.filterOptions.ConsumerType.length > 0
                    ? product.ConsumerType != null && this.state.filterOptions.ConsumerType.split(",").indexOf(product.ConsumerType.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "ConsumerVarietal" && this.state.filterOptions.ConsumerVarietal.length > 0
                    ? product.ConsumerVarietal != null && this.state.filterOptions.ConsumerVarietal.split(",").indexOf(product.ConsumerVarietal.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "Colour" && this.state.filterOptions.colour.length > 0
                    ? product.Colour != null && this.state.filterOptions.colour.split(",").indexOf(product.Colour.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "Container" && this.state.filterOptions.container.length > 0
                    ? product.Container != null && this.state.filterOptions.container.split(",").indexOf(product.Container.trim()) > -1
                    : true;
            })
                .filter((product) => {
                const volumeMinMax = this.state.filterOptions.volumeMinMax;
                return excludeFilter != "SizeAsFloat" && volumeMinMax.length > 0
                    ? product.SizeAsFloat >= volumeMinMax[0] && product.SizeAsFloat <= volumeMinMax[1]
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "AgentName" && this.state.filterOptions.agent.length > 0
                    ? this.state.filterOptions.agent.split(",").indexOf(product.AgentName.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "Supplier" && this.state.filterOptions.supplier.length > 0
                    ? product.Supplier != null && this.state.filterOptions.supplier.split(",").indexOf(product.Supplier.trim()) > -1
                    : true;
            })
                .filter((product) => {
                const alcMinMax = this.state.filterOptions.percAlcMinMax;
                return excludeFilter != "AlcoholAsFloat" && alcMinMax.length > 0
                    ? product.AlcoholAsFloat >= alcMinMax[0] && product.AlcoholAsFloat <= alcMinMax[1]
                    : true;
            })
                .filter((product) => {
                const sweetMinMax = this.state.filterOptions.sweetMinMax;
                return excludeFilter != "SweetnessAsFloat" && sweetMinMax.length > 0
                    ? product.SweetnessAsFloat >= sweetMinMax[0] && product.SweetnessAsFloat <= sweetMinMax[1]
                    : true;
            })
                .filter((product) => {
                const ibuMinMax = this.state.filterOptions.ibuMinMax;
                return excludeFilter != "IBU" && ibuMinMax.length > 0
                    ? product.IBU >= ibuMinMax[0] && product.IBU <= ibuMinMax[1]
                    : true;
            })
                .filter((product) => {
                return excludeFilter != "Aroma" && this.state.filterOptions.aroma.length > 0
                    ? product.Aroma != null && this.state.filterOptions.aroma.split(",").indexOf(product.Aroma.trim()) > -1
                    : true;
            })
                .filter((product) => {
                return !this.state.filterOptions.albertaMade || product.MadeInAlberta;
            })
                .value();
        };
        this.getProducts = (page) => {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products?$filter=Collections/any(o:(o/Id+eq+${this.props.id}))&$count=true&$orderby=${this.state.orderBy}`;
            if (this.props.id == 'Sponsored') {
                query = `${oDataPath}Collections/ConnectMobile.Web.SponsoredProducts()`;
            }
            axios
                .get(query)
                .then(response => {
                let products = response.data.value;
                if (this.props.id == 'Sponsored') {
                    products = response.data.value;
                }
                let filteredProducts = this.filterProducts(products);
                let skip = this.state.filterOptions.skip + 24;
                this.setState({
                    products: filteredProducts,
                    page,
                    count: filteredProducts.length,
                    loading: false,
                    categoryTypes: this.getFacet(products, "ConsumerType"),
                    categories: this.getFacet(products, "ConsumerCategory"),
                    FilterTypeOptions: {
                        Country: this.getFacet(products, "Country"),
                        Vintage: this.getFacet(products, "Vintage"),
                        Region: this.getFacet(products, "Region"),
                        Varietal: this.getFacet(products, "ConsumerVarietal"),
                        Colours: this.getFacet(products, "Colour"),
                        Containers: this.getFacet(products, "Container"),
                        Volumes: this.getFacet(products, "Size"),
                        Agents: this.getFacet(products, "AgentName"),
                        Suppliers: this.getFacet(products, "Supplier"),
                        PercentAlcohols: this.getFacet(products, "PercentAlcohol"),
                        Sweetnesses: this.getFacet(products, "Sweetness"),
                        Ibus: this.getFacet(products, "IBU"),
                        Aromas: this.getFacet(products, "Aroma"),
                    }
                    //filterOptions : {...this.state.filterOptions,skip }
                });
            });
        };
        this.state = {
            selectedCollection: {},
            products: [],
            categoryTypes: [],
            categories: [],
            count: 0,
            page: 1,
            loading: true,
            filterOptions: {
                skip: 0,
                top: 24,
                searchText: "",
                country: "",
                region: "",
                ConsumerCategory: "",
                ConsumerType: "",
                ConsumerVarietal: "",
                vintage: "",
                colour: "",
                container: "",
                volumeMinMax: [],
                agent: "",
                supplier: "",
                percAlcMinMax: [],
                sweetMinMax: [],
                ibuMinMax: [],
                aroma: "",
                albertaMade: false,
                sponsoredOnly: false
            },
            orderBy: 'Name+asc',
            FilterTypeOptions: {
                Country: [],
                Vintage: [],
                Region: [],
                Varietal: [],
                Colours: [],
                Containers: [],
                Volumes: [],
                Agents: [],
                Suppliers: [],
                PercentAlcohols: [],
                Sweetnesses: [],
                Ibus: [],
                Aromas: []
            }
        };
    }
    getCollection() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(${this.props.id})`;
            if (this.props.id == 'Sponsored') {
                query = `${oDataPath}Collections/ConnectMobile.Web.SponsoredProductCollection()`;
            }
            const response = yield axios.get(query);
            this.setState({
                selectedCollection: response.data
            });
        });
    }
    odataEncode(text) {
        return encodeURIComponent(text).replace(/'/g, "''");
    }
    filterToAzure(text) {
        let newText = text
            .split(",")
            .map(item => {
            return `"${item}"`;
        })
            .join("||");
        return text.length > 0 ? encodeURIComponent(newText) : "";
    }
    componentDidMount() {
        this.getProducts(this.state.page);
        this.getCollection();
    }
    render() {
        return (React.createElement(CollectionView, { selectedCollection: this.state.selectedCollection, categoryTypes: this.state.categoryTypes, categories: this.state.categories, products: this.state.products, getProducts: this.getProducts, typeSelected: this.state.filterOptions.ConsumerType, country: this.state.filterOptions.country, region: this.state.filterOptions.region, vintage: this.state.filterOptions.vintage, varietal: this.state.filterOptions.ConsumerVarietal, category: this.state.filterOptions.ConsumerCategory, colour: this.state.filterOptions.colour, container: this.state.filterOptions.container, volumeMinMax: this.state.filterOptions.volumeMinMax, agent: this.state.filterOptions.agent, supplier: this.state.filterOptions.supplier, percAlcMinMax: this.state.filterOptions.percAlcMinMax, sweetMinMax: this.state.filterOptions.sweetMinMax, ibuMinMax: this.state.filterOptions.ibuMinMax, aroma: this.state.filterOptions.aroma, count: this.state.count, page: this.state.page, FilterTypeOptions: this.state.FilterTypeOptions, updateSubFilter: this.updateSubFilter, updateMinMaxFilter: this.updateMinMaxFilter, updateOrderBy: this.updateOrderBy, currentOrderBy: this.state.orderBy, orderByOptions: this.orderByOptions, albertaMade: this.state.filterOptions.albertaMade, updateAlbertaMade: this.updateAlbertaMade, loading: this.state.loading }));
    }
}
//# sourceMappingURL=collections.js.map